<div class="container-fluid" style="overflow-x: hidden;">
  <form [formGroup]="myFormGroup" (ngSubmit)="onSubmit(myFormGroup)">
  <div class="row mb-1" *ngFor="let form_elem of arrFiltros[0].FiltrosExpuestos">
    <div class="col-12">
      <ng-container [ngSwitch]="form_elem.type">
        <ng-container *ngSwitchCase="'select_multiple'">
          <div class="mt-1 mb-1">
            <label for="{{form_elem.label}}">{{form_elem.title}}</label>
            <ng-select id="{{form_elem.label}}" formControlName="{{form_elem.label}}"
              [readonly]="form_elem.disabled=='S' || form_elem.A04MOD == 'N'" [items]="form_elem.options"
              (search)="cargarCombo($event, form_elem)" bindLabel="text" bindValue="value" multiple="true">
            </ng-select>
            <span *ngIf="form_elem.SYS03HLP">{{form_elem.SYS03HLP}}</span>
            <div *ngIf="form_elem.validators.required">
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'textbox_date'">
          <div class="mt-1 mb-1">
            <label for="{{form_elem.label}}">{{form_elem.title}}</label>
            <input type="date" id="filtro_{{form_elem.label}}" name="{{form_elem.label}}"
              placeholder="{{form_elem.placeholder}}" [readonly]="form_elem.disabled=='S'"
              formControlName="{{form_elem.label}}" class="form-control">
            <div *ngIf="form_elem.validators.required">
              <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                {{form_elem.validators.msg_validacion}}
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="'textbox'">
          <div class="mt-1 mb-1">
            <label for="{{form_elem.label}}">{{form_elem.title}}</label>
            <input type="text" id="filtro_{{form_elem.label}}" name="{{form_elem.label}}"
              placeholder="{{form_elem.placeholder}}" [readonly]="form_elem.disabled=='S'"
              formControlName="{{form_elem.label}}" class="form-control">
            <div *ngIf="form_elem.validators.required">
              <span *ngIf="this.myFormGroup.controls[form_elem.label].invalid" class="alert-requerido">
                {{form_elem.validators.msg_validacion}}
              </span>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <button type="submit" title="Filtrar" class="btn btn-sm btn-info btn-label waves-light"
        style=" width: 100%; font-size: medium; font-weight: bold;">
        <i class="fas fa-search label-icon" style="pointer-events: none;"></i> Filtrar
      </button>
    </div>
  </div>
  </form>
</div>